import React, { useEffect, useState } from 'react';
import { Button, Avatar, Icon, Collapse, Tooltip, Radio, Popconfirm, message } from 'antd';
import {
  DetailsCard,
  UserProfilecover,
  UserDetailHeadingCover,
  TeamDetailsCard,
  ChangeSmtpRadio,
} from './styles';
import Loader from '../../components/Loader';
import { LoginContainer } from '../../components/Modals/styles';
import {
  fetchAllPrinters,
  changeDefaultPrinter,
  validatePrinterConnection,
  testPrintPage,
} from '../../utils/services/mailRoomAPI';
import { PrinterConfigModal, TagConfigModal } from '../../components/Modals';
import DeleteSMTPConfigModal from '../../components/Modals/DeleteSMTPConfigModal';
import { PagesIcon, PrinterPageIcon } from '../../images/svgIcons';
import { withTranslation } from 'react-i18next';
import { MANAGE_PRINTER_SETTINGS as trans } from './TranslationValues';
import { getClientOrganisationDetails } from '../../utils/services/onPremAPI';

const NAMESPACE = ['MANAGE_PRINTER_SETTINGS'];
const PrinterSettings = props => {
  const { isEditable, t } = props;
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [tagModalVisible, setTagModalVisible] = useState(false);
  const [changeDefault, isChangeDefault] = useState(false);
  const [defaultSMTPID, setDefaultSMTPID] = useState(null);
  const [isValidPrinter, setIsValidPrinter] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [isValidPrinterPage, setValidPrinterPage] = useState(null);
  const [validatingPrinterPage, setValidatingPrinterPage] = useState(false);
  const [userDetails, setUserDetails] = useState([]);
  const { Panel } = Collapse;

  useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);

  const fetchData = async () => {
    const response = await fetchAllPrinters();
    if (response && response.errors && response.errors.length === 0) {
      const orgData = await getClientOrganisationDetails();
      response.data.features = orgData.features ?? null;
      setUserDetails(response?.data);
    }
    setLoading(false);
  };

  const onSuccess = () => {
    setShowModal(false);
    setIsEditing(false);
    fetchData();
  };

  const handleDelete = isDeleted => {
    setDeleteModalVisible(false);
    if (isDeleted) {
      fetchData();
    }
  };

  const defaultChange = async e => {
    isChangeDefault(false);
    let response = await changeDefaultPrinter(e);
    if (response)
      if (response.errors && response.errors.length === 0 && response.statusCode === 1554) {
        message.success(t(trans.SET_DEFAULT_PRINTER_SUCCESS.key, trans.SET_DEFAULT_PRINTER_SUCCESS.value));
        fetchData();
      } else {
        message.success(t(trans.SET_DEFAULT_PRINTER_FAILURE.key, trans.SET_DEFAULT_PRINTER_FAILURE.value));
      }
  };

  const validatePrinter = async value => {
    if (selectedItem.id !== value.id) {
      setIsValidPrinter(null);
      setValidPrinterPage(null);
    }
    setIsValidating(true);
    let payload = {
      // id: value.id,
      printerIPAddress: value.printerIPAddress,
      // password: value.password,
      // port: value.port,
      // printerName: value.printerName,
      // protocol: value.protocol,
    };
    let response = await validatePrinterConnection(payload);
    if (response) {
      setIsValidating(false);
      if (response.errors && response.errors.length === 0) {
        setIsValidPrinter(true);
      } else {
        setIsValidPrinter(false);
      }
    }
  };

  const validatePrinterPage = async value => {
    if (selectedItem.id !== value.id) {
      setIsValidPrinter(null);
      setValidPrinterPage(null);
    }
    setValidatingPrinterPage(true);
    let payload = {
      printerName: value.printerName,
    };
    let response = await testPrintPage(payload);
    if (response) {
      setValidatingPrinterPage(false);
      if (response.errors && response.errors.length === 0) {
        setValidPrinterPage(true);
      } else {
        setValidPrinterPage(false);
      }
    }
  };

  const renderList = () => {
    return (
      <Collapse accordion>
        {userDetails &&
          userDetails.map((value, key) => {
            return (
              <Panel
                disabled={true}
                key={key}
                showArrow={false}
                header={
                  <DetailsCard key={key} smtp={1}>
                    {changeDefault && (
                      <Radio.Group
                        onChange={e => setDefaultSMTPID(value.id)}
                        value={value.default ? value.id : defaultSMTPID}
                      >
                        {value.default ? (
                          <Radio value={value.id} />
                        ) : (
                          <Popconfirm
                            title={
                              <ChangeSmtpRadio>
                                {t(trans.DEFAULT_PRINTER_CHANGE_CONFIRMATION_TITLE.key,trans.DEFAULT_PRINTER_CHANGE_CONFIRMATION_TITLE.value)}                              
                              </ChangeSmtpRadio>
                            }
                            onConfirm={() => defaultChange(defaultSMTPID)}
                            onCancel={() => isChangeDefault(false)}
                            okText={t(trans.DEFAULT_PRINTER_CHANGE_CONFIRMATION_YES_BUTTON.key, trans.DEFAULT_PRINTER_CHANGE_CONFIRMATION_YES_BUTTON.value)}
                            cancelText={t(trans.DEFAULT_PRINTER_CHANGE_CONFIRMATION_No_BUTTON.key,trans.DEFAULT_PRINTER_CHANGE_CONFIRMATION_No_BUTTON.value)}
                          >
                            <Radio value={value.id} />
                          </Popconfirm>
                        )}
                      </Radio.Group>
                    )}
                    <UserProfilecover permission={true}>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          width: '50%',
                        }}
                      >
                        <Avatar className="avatar">
                          {value?.printerName?.charAt(0).toUpperCase()}
                        </Avatar>
                        <p>{value.printerName}</p>
                      </div>
                    </UserProfilecover>
                    {value.default && (
                      <Tooltip
                        placement="top"
                        title={
                          isEditable && !changeDefault
                            ? t(trans.CHANGE_DEFAULT_PRINTER_TOOLTIP.key,trans.CHANGE_DEFAULT_PRINTER_TOOLTIP.value)
                            : t(trans.CURRENT_DEFAULT_PRINTER_TOOLTIP.key,trans.CURRENT_DEFAULT_PRINTER_TOOLTIP.value)
                        }
                      >
                        <div
                          className="defaultSmtp"
                          onClick={() => isEditable && isChangeDefault(true)}
                        >
                          {t(trans.CURRENT_DEFAULT_PRINTER_ACTION.key,trans.CURRENT_DEFAULT_PRINTER_ACTION.value)}
                        </div>
                      </Tooltip>
                    )}
                  </DetailsCard>
                }
                extra={
                  <div
                    style={{
                      display: 'flex',
                      width: '150px',
                      justifyContent: 'space-around',
                      marginRight: '10px',
                      alignItems: 'center',
                      cursor: changeDefault && 'not-allowed',
                    }}
                    onClick={e => e.stopPropagation()}
                  >
                    <Tooltip
                      placement="top"
                      title={
                        selectedItem.id == value.id && isValidating
                          ? t(trans.PRINTER_CONNECTION_TESTING_TOOLTIP.key,trans.PRINTER_CONNECTION_TESTING_TOOLTIP.value)
                          : isValidPrinterPage && selectedItem.id == value.id
                          ? t(trans.VALID_PRINTER_TOOLTIP.key,trans.VALID_PRINTER_TOOLTIP.value)
                          : isValidPrinterPage !== null &&
                          !isValidPrinterPage &&
                          selectedItem.id == value.id
                          ? t(trans.INVALID_PRINTER_TOOLTIP.key,trans.INVALID_PRINTER_TOOLTIP.value)
                          : t(trans.TEST_PRINTER_IS_WORKING_ACTION_TOOLTIP.key,trans.TEST_PRINTER_IS_WORKING_ACTION_TOOLTIP.value)
                      }
                    >
                      <div
                        className="PageIcon"
                        onClick={() => {
                          setSelectedItem(value);
                          validatePrinterPage(value);
                        }}
                      >
                        {selectedItem.id == value.id && validatingPrinterPage ? (
                          <Icon type="loading" />
                        ) : isValidPrinterPage !== null &&
                          selectedItem.id == value.id &&
                          (isValidPrinterPage || !isValidPrinterPage) ? (
                          <div style={{ position: 'relative' }}>
                            <Icon
                              className="isValidPrinter page"
                              theme={'twoTone'}
                              twoToneColor={isValidPrinterPage ? '#52c41a' : '#ff0000'}
                              type={
                                isValidPrinterPage
                                  ? 'check-circle'
                                  : !isValidPrinterPage
                                  ? 'warning'
                                  : ''
                              }
                            />
                            {PrinterPageIcon()}
                          </div>
                        ) : (
                          PrinterPageIcon()
                        )}
                      </div>
                    </Tooltip>
                    <Tooltip
                      placement="top"
                      title={
                        selectedItem.id == value.id && isValidating
                          ? t(trans.PRINTER_CONNECTION_TESTING_TOOLTIP.key,trans.PRINTER_CONNECTION_TESTING_TOOLTIP.value)
                          : isValidPrinter && selectedItem.id == value.id
                          ? t(trans.VALID_PRINTER_TOOLTIP.key,trans.VALID_PRINTER_TOOLTIP.value)
                          : isValidPrinter !== null &&
                          !isValidPrinter &&
                          selectedItem.id == value.id
                          ? t(trans.INVALID_PRINTER_TOOLTIP.key,trans.INVALID_PRINTER_TOOLTIP.value)
                          : t(trans.TEST_PRINTER_CONNECTION_ACTION_TOOLTIP.key,trans.TEST_PRINTER_CONNECTION_ACTION_TOOLTIP.value)
                      }
                    >
                      <div style={{ position: 'relative' }}>
                        {isValidPrinter !== null && (
                          <Icon
                            className="isValidPrinter"
                            theme={selectedItem.id == value.id && !isValidating && 'twoTone'}
                            twoToneColor={
                              selectedItem.id == value.id &&
                              (isValidPrinter ? '#52c41a' : '#ff0000')
                            }
                            type={
                              isValidPrinter && selectedItem.id == value.id
                                ? 'check-circle'
                                : isValidPrinter !== null &&
                                  !isValidPrinter &&
                                  selectedItem.id == value.id
                                ? 'warning'
                                : ''
                            }
                          />
                        )}
                        <Icon
                          type={selectedItem.id == value.id && isValidating ? 'loading' : 'printer'}
                          className={changeDefault && 'disabled'}
                          onClick={() => {
                            setSelectedItem(value);
                            validatePrinter(value);
                          }}
                        />
                      </div>
                    </Tooltip>
                    <Tooltip placement="top" title={t(trans.DELETE_PRINTER_BUTTON.key,trans.DELETE_PRINTER_BUTTON.value)}>
                      <Icon
                        type="delete"
                        className={changeDefault && 'disabled'}
                        onClick={() => {
                          setSelectedItem(value);
                          setDeleteModalVisible(true);
                        }}
                      />
                    </Tooltip>
                  </div>
                }
              ></Panel>
            );
          })}
      </Collapse>
    );
  };

  return (
    <>
      {loading ? (
        <LoginContainer>
          <Loader />
        </LoginContainer>
      ) : (
        <>
          <UserDetailHeadingCover isPrinter={1}>
            <div>
              <h5>{t(trans.MANAGE_PRINTER_SETTINGS_TITLE.key,trans.MANAGE_PRINTER_SETTINGS_TITLE.value)}</h5>
              <p>{t(trans.MANAGE_PRINTER_SETTINGS_DESCRIPTION.key,trans.MANAGE_PRINTER_SETTINGS_DESCRIPTION.value)}</p>
              <div className="ldap_config" onClick={() => setTagModalVisible(true)}>
              <p>{t(trans.OPEN_MAPPING_MODAL_BUTTON.key,trans.OPEN_MAPPING_MODAL_BUTTON.value)}</p>
                <Icon type="edit" />
              </div>
            </div>
            <Button
              type="primary"
              className="add_user_btn"
              onClick={() => {
                if (!changeDefault) {
                  setShowModal(true);
                  setSelectedItem({});
                  setIsEditing(false);
                } else {
                  isChangeDefault(false);
                }
              }}
            >
              {!changeDefault ? t(trans.ADD_NEW_PRINTER_BUTTON.key,trans.ADD_NEW_PRINTER_BUTTON.value) : t(trans.CANCEL_NEW_PRINTER_CONFIGURATION_BUTTON.key,trans.CANCEL_NEW_PRINTER_CONFIGURATION_BUTTON.value)}
            </Button>
          </UserDetailHeadingCover>
          <TeamDetailsCard printer={1} default={changeDefault}>
            {renderList()}
          </TeamDetailsCard>
          {showModal && (
            <PrinterConfigModal
              onCancel={() => {
                setShowModal(false);
                setIsEditing(false);
              }}
              onSuccess={onSuccess}
              isEditing={isEditing}
              selectedItem={selectedItem}
              target={selectedItem}
            />
          )}
          {tagModalVisible && (
            <TagConfigModal
              onCancel={() => {
                setTagModalVisible(false);
                setIsEditing(false);
              }}
              onSuccess={onSuccess}
              isEditing={isEditing}
              isEditable={isEditable}
              selectedItem={selectedItem}
              target={selectedItem}
            />
          )}
          {deleteModalVisible && (
            <DeleteSMTPConfigModal
              visible={deleteModalVisible}
              targetUser={selectedItem}
              onCancel={handleDelete}
              isDeletePrinter={true}
            />
          )}
        </>
      )}
    </>
  );
};
export default withTranslation(NAMESPACE)(PrinterSettings);
